define('views/lib/Podio.Views.Composer',['require','underscore','jquery','lib/jquery/jquery.bounds','lib/jquery/jquery.elastic','lib/backbone/Backbone.PodioView','views/lib/Podio.Views.SubmitToggler','lib/mentionsinput/PodioMentionsInput','lib/Podio.Emojis','lib/Giphys','lib/Podio.Viewport','lib/Podio.UI.FormEmbedActions','lib/Podio.Transport.Mentions','lib/Podio.UI.Embeds','lib/Podio.UI.Questions','lib/Podio.FormValidation','lib/Podio.UI','jst!lib/_composer','jst!shared/_common_form_embed_actions'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.bounds');
  require('lib/jquery/jquery.elastic');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var SubmitTogglerView = require('views/lib/Podio.Views.SubmitToggler');
  var PodioMentionsInput = require('lib/mentionsinput/PodioMentionsInput');
  var Emojis = require('lib/Podio.Emojis');
  var Giphys = require('lib/Giphys');

  var PodioViewport = require('lib/Podio.Viewport');

  var formEmbedActions = require('lib/Podio.UI.FormEmbedActions');
  var transportMentions = require('lib/Podio.Transport.Mentions');
  var embeds = require('lib/Podio.UI.Embeds');
  var questions = require('lib/Podio.UI.Questions');
  var formValidation = require('lib/Podio.FormValidation');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;

  var jstComposer = require('jst!lib/_composer');
  var jstCommonFormEmbedActions = require('jst!shared/_common_form_embed_actions');

  const MAX_CHAR_LIMIT = 1000;

  return PodioView.extend({

    className: 'comment-composer embed-actions-wrapper',         /* still called comment-composer for compatibility reasons */

    podioEvents: {
      'focus default .composer-input'     : 'onInputFocus',
      'keyup .composer-input'             : 'onInputKeyUp',
      'keyup .composer-input textarea'    : 'onInputKeyUpDebounced',
      'keydown default .composer-input'   : 'onInputKeyDown',
      'input default .composer-input'     : 'onInputChange'
    },

    initialize: function( options ) {
      _.bindAll(this, 'render', 'getMentionsData', 'onInputResized', 'focus');

      this.addDisabledProxy(['onInputFocus', 'onInputKeyUp', 'onInputKeyUpDebounced', 'onInputKeyDown', 'onInputChange']);

      this._super();

      this.elmWindow = $(window);
      this.elmContainer = this.options.elmContainer;

      // Options
      this.isTypingtimer = null;
      this.options.textareaTabIndex = this.options.tabindex + 1;

      this.translations = options.translations;

      this.eventBus.bind('submitToggler:toggleChanged', this.onSubmitTogglerToggleChanged, this);
      this.eventBus.bind('submitToggler:submitTriggered', this.onSubmitTogglerSubmit, this);

      this.viewportHelper = new PodioViewport();
    },

    /**
     * Proxy provided event handlers to emulate disabled functionality of the textarea
     * instead of using the "disabled" attribute, which forces unfocusing.
     * @param {Array.<Function>} funcs
     */
    addDisabledProxy: function(funcs) {
      var self = this;

      _.each(funcs, function(f) {
        self[f] = _.wrap(self[f], function(originalFunc, elmTarget, e) {
          var args = _.toArray(arguments);
          var elmTextarea = elmTarget.find('textarea');

          if (elmTextarea.hasClass('disabled')) {
            e.preventDefault();
            e.stopPropagation();

            return false;
          } else {
            originalFunc.apply(self, _.rest(args));
          }
        });
      });
    },

    dispose: function() {

      this.eventBus.unbind('submitToggler:toggleChanged', this.onSubmitTogglerToggleChanged);
      this.eventBus.unbind('submitToggler:submitTriggered', this.onSubmitTogglerSubmit);

      if (this.submitTogglerView) {
        this.submitTogglerView.dispose();
      }

      if (this.mentionsInput) {
        this.mentionsInput.destroy();
      }

      this._super();
    },


    render: function() {
      this.elm.html(this.getTemplate(jstComposer, { options: this.options, jstCommonFormEmbedActions: jstCommonFormEmbedActions }));

      // Insert into DOM
      this.elm.insertAfter(this.elmContainer);

      // References
      this.elmComposer = this.elm.find('.composer-new');
      this.elmButtonsWrapper = this.elm.find('.composer-buttons');
      this.elmInput = this.elm.find('.composer-input textarea');
      this.elmSubmit = this.elm.find('.submit-toggler-submit');
      this.elmExtras = this.elm.find('.composer-extras');
      this.elmActionBox = this.elmExtras.find('.action-box');

      var canMention = this.getOption('canMention');
      var canEmoji = this.getOption('canEmoji');

      if (canMention || canEmoji) {
        this.elm.data('mentions', true);

        var triggers = {};

        if (canMention) {
          triggers['@'] = this.getMentionsData;
        }
        if (canEmoji) {
          triggers[':'] = Emojis.load;
          triggers['::'] = Giphys.load;
        }

        this.mentionsInput = new PodioMentionsInput(this.elmInput, {
          autoCompleterDirection: 'top',
          triggers: triggers
        });

      } else {
        this.elmInput.elastic();
      }

      this.elmInput.on('elementResized', this.onInputResized);

      if (this.options.spaceId) {
        this.elm.data('space-id', this.options.spaceId);
      }

      // Submit toggler
      if (!this.options.hideSubmitButton) {
        this.submitTogglerView = new SubmitTogglerView({
          el : this.elmButtonsWrapper.get(0),
          eventBus : this.eventBus,
          isToggled : this.options.returnSubmit,
          disableTabIndex: this.options.disableTabIndex,
          tabindex: this.options.tabindex,
          submitButtonOptions : {
            label: this.translations.submitButton,
            color: 'primary baby-button'
          }
        });

        this.submitTogglerView.render();
      }

      if (this.options.takeFocus) {
        this.focus();
      }

    },

    focus: function() {
      var self = this;
      _.defer(function() {
        self.elmInput.focus();
      });
    },

    updatePosition: function() {
      var bounds = $('.main-content .col:first').bounds();
      this.elmComposer.css({
        left: bounds.left + 20,
        width: bounds.width - 40 // marginLeft + marginRight
      });
    },

    disableMentions: function() {
      this.elm.data('mentions', false);
    },

    enableMentions: function(newSpaceId) {
      this.elm.data('mentions', true);
      if (newSpaceId) {
        this.elm.data('space-id', newSpaceId);
      }
    },

    getMentionsData: function(mode, query, callback) {

      var req = transportMentions.getMentionsData(query, this.options.spaceId);

      req.done(function(responseData) {
        if ( responseData.data.items ) {
          callback.apply(this, [responseData.data.items]);
        }
      });
    },

    restoreButton: function() {
      if (this.submitTogglerView) {
        this.submitTogglerView.restoreButton();
      }

      this.elmInput.removeClass('disabled');
    },

    disableButton: function() {

      if (this.submitTogglerView) {
        this.submitTogglerView.disableButton();
      }
      this.elmInput.addClass('disabled');
    },

    setInput: function(text) {
      this.elmInput.val(text);
    },

    clearInput: function() {
      if (this.mentionsInput) {
        this.mentionsInput.resetInput();
      } else {
        this.elmInput.val('');
      }
    },

    restoreComposer: function() {
      formEmbedActions.reset(this.elmActionBox);
      embeds.clearEmbedInfo(this.elmActionBox);
      this.clearInput();
      this.restoreButton();
      // force elastic to recalculate
      this.elmInput.trigger('focus');
    },

    detectIsTyping: function() {
      var view = this;
      var value = this.elmInput.val();

      if (value.length) {

        if (this.isTypingtimer) {
          return; // Timer already set
        }

        this.isTypingtimer = setTimeout(function() {
          view.trigger('composer:typingStarted');
        }, 1500);

      } else {
        this.stopIsTypingTimer();
      }
    },

    isFullyVisible: function() {
      var viewportInfo = this.viewportHelper.getInfo(this.elm);
      return viewportInfo.isWithinViewportBottomEdge;
    },

    stopIsTypingTimer: function() {
      clearTimeout(this.isTypingtimer);
      this.isTypingtimer = null;
      this.trigger('composer:typingStopped');
    },

    onInputKeyDown: function(elmTarget, e) {
      if ((this.options.returnSubmit && e.keyCode === keyCodes.Return && !e.shiftKey) || (!this.options.returnSubmit && e.keyCode === keyCodes.Return && (e.ctrlKey || e.metaKey))) {
        this.onSubmitTogglerSubmit();
        if (this.options.charCount){
          this.resetTextarea();
        }         
        e.preventDefault();
      }
    },

    onInputKeyUp: function(elmTarget, e) {
      this.detectIsTyping();
    },

    onInputKeyUpDebounced: _.debounce(function(elmTarget, e) {
      formEmbedActions.handleAutoLinking(this.elmActionBox, this.elmInput);
    }, 500),

    onInputFocus: function(elmTarget, e) {
      this.setActiveClass();

      this._showActions();

      if (this.submitTogglerView) {
        this.submitTogglerView.refresh();
      }

      this.trigger('composer:focus');
    },

    onInputChange: function() {
      var text = this.elmInput.val();
      if (this.options.charCount){
        var textlength = text.length;

        if (textlength > MAX_CHAR_LIMIT) {
          text = text.slice(0, MAX_CHAR_LIMIT);  // Truncate text to MAX_CHAR_LIMIT characters
          textlength = text.length;
          this.elmInput.val(text);  // Update textarea value with truncated text
          this.elmInput.addClass('error').focus();
        }
        else {
          this.elmInput.removeClass('error');
        }
        
        // Always update the placeholder with the current text length
        this.trigger('composer:changed', text, textlength); 
        $('.char-count').text(textlength + '/' + `${MAX_CHAR_LIMIT}`);
      }
      else {
        this.trigger('composer:changed', text);
      }
    },

    resetTextarea: function() {
      this.elmInput.val('');
      $('.char-count').text('0/' + MAX_CHAR_LIMIT);
    },

    onSubmitTogglerToggleChanged: function(isToggled) {
      this.options.returnSubmit = isToggled;
      this.focus();
      this.trigger('composer:submitToggleChanged', isToggled);
    },

    onSubmitTogglerSubmit: function() {
      var data = {
        ref: this.options.commentable
      };

      var embedInfo = embeds.getCurrentEmbedInfo(this.elmActionBox);
      if (embedInfo) {
        data['embed_id'] = embedInfo.embed_id;
        if (embedInfo.selected_file_id) {
          data['embed_file_id'] = embedInfo.selected_file_id;
        }
      }

      data['file_ids'] = this.elm.find('.files-hidden-input').val();

      var answersList = questions.collectAnswers(this.elmActionBox);
      if (answersList) {
        data['question-answer'] = answersList;
      }

      // Form validation
      formValidation.init(this.elm.find('form'));
      if (!this.elm.find('form').valid()) {
        return;
      }

      // Abort any running embed create requests
      if (embeds.abortEmbedCreate(this.elmActionBox)) {
        formEmbedActions.reset(this.elmActionBox);
      }

      this.disableButton();

      this.stopIsTypingTimer();

      // Write mentions to textarea value
      if (this.elm.data('mentions')) {
        data['value'] = this.mentionsInput.val();
      } else {
        data['value'] = this.elmInput.val();
      }
      this.trigger('composer:submit', data);
    },

    onInputResized: function() {
      this.trigger('composer:resized');
    },

    _showActions: function() {
      var self = this;
      this.elmExtras.fadeIn('fast');
      this.elmExtras.promise().done(function() {
        self.trigger('composer:resized');
      });
    },

    setActiveClass: function() {
      this.elmComposer.addClass('active');
    },

  });

});

